import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jwtAuthAxios from "services/jwtAuth";

export const viewJadwalMahasiswa = createAsyncThunk("jadwalMahasiswa/viewJadwalMahasiswa", async(payload) => {
  let token = localStorage.getItem('auth_token');
  let roles = localStorage.getItem('roles')
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  if (roles.includes('ADMIN')){
    const response = await jwtAuthAxios.post('/v1/jadwal/mahasiswa/all', payload);
    return response.data;
  } else {
    const idMahasiswa = localStorage.getItem('id');
    const response = await jwtAuthAxios.post('/v1/jadwal/mahasiswa/id', { ...payload, id_mahasiswa: idMahasiswa });
    return response.data;
  }
});

export const getJadwalMhs = createAsyncThunk("jadwalMahasiswa/getJadwalMhs", async(payload) => {
  let token = localStorage.getItem('auth_token');
  jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  const idMahasiswa = localStorage.getItem('id');
  const response = await jwtAuthAxios.post('/v1/jadwal/mahasiswa/id', payload);
  return response.data;
});


const initialState = {
  loading: false,
  listJadwal:[],
  dataJadwalMhs:[]
}

const jadwalMahasiswaSlice = createSlice({
  name: "jadwalMahasiswa",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(viewJadwalMahasiswa.pending, (state) => {
          state.loading = true;
        })
        .addCase(viewJadwalMahasiswa.fulfilled, (state, action) => {
          state.listJadwal = action.payload
          state.loading = false;
        })
        .addCase(viewJadwalMahasiswa.rejected, (state, action) => {
          state.loading = false;
          console.error("Error:", action.error);
        })
    builder
        .addCase(getJadwalMhs.pending, (state) => {
          state.loading = true;
        })
        .addCase(getJadwalMhs.fulfilled, (state, action) => {
          state.dataJadwalMhs = action.payload
          state.loading = false;
        })
        .addCase(getJadwalMhs.rejected, (state, action) => {
          state.loading = false;
          console.error("Error:", action.error);
        })
  }
})

export const jadwalMahasiswaSelector = (state) => state.jadwalMahasiswa;
export default jadwalMahasiswaSlice.reducer;


